import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SharedService } from '../../shared.service';

@Injectable()
export class ConfirmationGuard implements CanActivate {
  constructor(private sharedService: SharedService) {}

  canActivate() {
    return this.sharedService.checkLocalStorage('addressData') ? true : false;
  }
}
